import { render, staticRenderFns } from "./AgregarAlmacen.vue?vue&type=template&id=96ea1864&"
import script from "./AgregarAlmacen.vue?vue&type=script&lang=js&"
export * from "./AgregarAlmacen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports